import React from 'react';
import styles from "./App.module.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useGlobalContext } from "./context/Appcontext";
import SalesChat from './pages/SalesChat/ChatBox';
import DoctorChat from './pages/DoctorChat/ChatBox';
import Login from './pages/Login/Login';
import AppLayout from './components/layout';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import PublicBot from './pages/publicBot';

const theme = createTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif",
  },
});

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useGlobalContext();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
}



function App() {
  return (
    <div className={styles.App}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppLayout>
        <Routes>
          {/* Public Route */}
          <Route path='/login' element={<Login />} />
          <Route path="/public" element={<PublicBot/> }/>
          {/* <Route path="/doctor" element={
              <DoctorChat />
          } /> */}

          {/* Protected Routes */}
          <Route path="/doctor" element={
            <ProtectedRoute>
              <DoctorChat />
            </ProtectedRoute>
          } />
           <Route path="/sales" element={<ProtectedRoute><SalesChat /></ProtectedRoute>} />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/login" />} />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AppLayout>
    </ThemeProvider>
  </div>
  );
}

export default App;
